import { render, staticRenderFns } from "./CampaignsName.vue?vue&type=template&id=088fdfb3&scoped=true&lang=pug"
import script from "./CampaignsName.vue?vue&type=script&lang=js"
export * from "./CampaignsName.vue?vue&type=script&lang=js"
import style0 from "./CampaignsName.vue?vue&type=style&index=0&id=088fdfb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088fdfb3",
  null
  
)

export default component.exports